import { render } from "./DraftSavedModal.vue?vue&type=template&id=98307266&scoped=true"
import script from "./DraftSavedModal.vue?vue&type=script&lang=js"
export * from "./DraftSavedModal.vue?vue&type=script&lang=js"

import "./DraftSavedModal.vue?vue&type=style&index=0&id=98307266&lang=css"
import "./DraftSavedModal.vue?vue&type=style&index=1&id=98307266&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-98307266"

export default script